import { z } from "zod";
import { phoneNumberSchema } from "@/utils/zod.ts";

export const accountManagerAttributesSchema = z.object({
    fullName: z.string(),
    emailAddress: z.string(),
    phoneNumber: phoneNumberSchema,
    photoObjectKey: z.string(),
});
